export default {
  INIT_STATE: "INIT_STATE",
};
